module.exports = "<uch></uch>\r\n<work-header params=\"current:'workflow'\"></work-header> \r\n<div class=\"work_content\">\r\n    <div class=\"userContent\">\r\n        <work-applist></work-applist>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/workflow/workflowIndex.html
// module id = 196
// module chunks = 0